import { motion } from "framer-motion";

const SHOTS = [
  {
    src: "https://images.unsplash.com/photo-1726729538481-e0d8d913264e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9vZHklMjBmYXJtJTIwbGFuZHNjYXBlJTIwTW91bnQlMjBBbGJlcnR8ZW58MHx8fHwxNzg2MTgxNzExfDA&ixlib=rb-4.1.0&q=85",
    caption: "Dusk over the back field",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_garlic-luxury-1/artifacts/4icvb3cb_20250806_103443.webp",
    caption: "This season's bulbs, bench-cured",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1621494547944-5ddbc84514b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjaGVmJTIwY29va2luZyUyMGRhcmslMjBraXRjaGVuJTIwdmVnZXRhYmxlfGVufDB8fHx8MTc4NjE4MTcxMXww&ixlib=rb-4.1.0&q=85",
    caption: "From our rows to the pass",
    span: "",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_garlic-luxury-1/artifacts/vk86kjkr_20250806_111119.webp",
    caption: "The basket, mid-harvest",
    span: "md:row-span-2",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_garlic-luxury-1/artifacts/z34rovia_IMG-20260323-WA0020.webp",
    caption: "Burning off the north field, early spring",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1758221055853-479a0de23e66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxoZWlybG9vbSUyMHRvbWF0b2VzJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg2MTgxNjk5fDA&ixlib=rb-4.1.0&q=85",
    caption: "Heirlooms at first light",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1638100345650-f26df74d980d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxoZWlybG9vbSUyMHRvbWF0b2VzJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg2MTgxNjk5fDA&ixlib=rb-4.1.0&q=85",
    caption: "The cherry jewel-box",
    span: "md:col-span-2",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_garlic-luxury-1/artifacts/u90q0q3i_20260807_183306.webp",
    caption: "The morning's crate",
    span: "",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_garlic-luxury-1/artifacts/6sfm6czv_20260710_120546.webp",
    caption: "A crate of colour, mid-season",
    span: "md:row-span-2",
  },
  {
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_garlic-luxury-1/artifacts/dh4yc9bm_20260806_114935.webp",
    caption: "Heirlooms, just picked",
    span: "md:col-span-2",
  },
  {
    src: "/images/harvest-flatlay.webp",
    caption: "The whole haul, laid bare",
    span: "md:col-span-2",
  },
  {
    src: "/images/chard-crate.webp",
    caption: "Rainbow chard, crate-fresh",
    span: "",
  },
  {
    src: "/images/sage-scarecrow.webp",
    caption: "The Sage, on duty",
    span: "md:row-span-2",
  },
  {
    src: "/images/dog-ball.webp",
    caption: "Harley, the real boss, on break",
    span: "md:col-span-2",
  },
  {
    src: "/images/dog-window.webp",
    caption: "Negotiations at the window",
    span: "",
  },
  {
    src: "/images/dog-door.webp",
    caption: "Harley on greenhouse security",
    span: "",
  },
  {
    src: "/images/greenhouse-hq.webp",
    caption: "Headquarters",
    span: "md:col-span-2",
  },
  {
    src: "/images/farmer-field.webp",
    caption: "Scaping the garlic, June",
    span: "md:row-span-2",
  },
  {
    src: "/images/harley-harvest.webp",
    caption: "Harley, harvest supervisor",
    span: "",
  },
  {
    src: "/images/harley-field-rest.webp",
    caption: "Harley, off the clock",
    span: "md:col-span-2",
  },
  {
    src: "/images/harley-beets.webp",
    caption: "Harley inspecting the beets",
    span: "",
  },
  {
    src: "/images/harley-planter.webp",
    caption: "Harley & the flower fund",
    span: "",
  },
  {
    src: "/images/greenhouse-nursery.webp",
    caption: "The spring nursery",
    span: "md:col-span-2",
  },
  {
    src: "/images/tomato-greenhouse.webp",
    caption: "The tomato cathedral",
    span: "md:col-span-2",
  },
  {
    src: "/images/chayote-arbor.webp",
    caption: "Chayote on the arbor",
    span: "",
  },
  {
    src: "/images/ridged-gourd.webp",
    caption: "The climbing gourd",
    span: "md:row-span-2",
  },
  {
    src: "/images/clove-breaking.webp",
    caption: "Clove by clove — planting prep",
    span: "",
  },
  {
    src: "/images/harvest-crate-2.webp",
    caption: "The harvest crate, top-down",
    span: "md:row-span-2",
  },
];

export default function Gallery() {
  return (
    <main data-testid="gallery-page" className="pt-40 pb-32">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="mb-20 max-w-2xl"
        >
          <p className="overline-tag mb-6">Field Notes</p>
          <h1 className="font-display text-5xl sm:text-6xl tracking-tighter font-light text-zinc-100 leading-[1.05]">
            Life on the <span className="italic text-saffron">rows</span>
          </h1>
          <p className="mt-8 text-base leading-relaxed text-zinc-400">
            Mud, saffron light, and the quiet theatre of things growing. Mount Albert, Ontario.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[220px] gap-4">
          {SHOTS.map((s, i) => (
            <motion.figure
              key={s.src + i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.1 }}
              className={`group relative overflow-hidden border border-line ${s.span}`}
            >
              <img
                src={s.src}
                alt={s.caption}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0A0A0A]/90 to-transparent p-5 text-xs uppercase tracking-[0.2em] text-zinc-300 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                {s.caption}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </main>
  );
}
